
import React from 'react';
import { Home, Users, ClipboardList, Package, Store, BarChart3, CheckSquare, Wrench, UserCog, ShoppingCart } from 'lucide-react';
import { cn } from '@/lib/utils';
import { SidebarLogo } from './sidebar/SidebarLogo';
import { SidebarMenuItem } from './sidebar/SidebarMenuItem';
import { SidebarRentalSubmenu } from './sidebar/SidebarRentalSubmenu';
import { SidebarToggle } from './sidebar/SidebarToggle';
import { useSidebarState } from './sidebar/useSidebarState';
import { useOpenTasksCount } from '@/hooks/tasks/useOpenTasksCount';

interface SidebarProps {
  collapsed: boolean;
  onToggle: () => void;
}

const mainMenuItems = [
  {
    title: 'Главная',
    path: '/main',
    icon: Home,
    dataOnboard: undefined
  },
  {
    title: 'Клиенты',
    path: '/clients',
    icon: Users,
    dataOnboard: 'nav-clients'
  },
  {
    title: 'Заказы',
    path: '/orders',
    icon: ShoppingCart,
    dataOnboard: undefined
  },
  {
    title: 'Инвентарь',
    path: '/inventory',
    icon: Package,
    dataOnboard: 'nav-inventory'
  },
  {
    title: 'Магазин',
    path: '/store',
    icon: Store,
    dataOnboard: undefined
  },
  {
    title: 'Мастерская',
    path: '/workshop',
    icon: Wrench,
    dataOnboard: undefined
  },
  {
    title: 'Персонал',
    path: '/staff',
    icon: UserCog,
    dataOnboard: undefined
  },
  {
    title: 'Отчёты',
    path: '/reports',
    icon: BarChart3,
    dataOnboard: undefined
  },
  {
    title: 'Задачи',
    path: '/tasks',
    icon: CheckSquare,
    dataOnboard: undefined
  }
];

const Sidebar = ({ collapsed, onToggle }: SidebarProps) => {
  const { currentPath, rentalSubmenuOpen, isRentalActive, toggleRentalSubmenu } = useSidebarState();
  const { displayCount, badgeVariant } = useOpenTasksCount();

  return (
    <div className={cn(
      "hidden desktop:flex flex-col h-screen bg-white fixed left-0 top-0 shadow-sm transition-all duration-300 ease-in-out",
      collapsed ? "w-16" : "w-56"
    )}>
      <SidebarLogo collapsed={collapsed} />
      
      <nav className="flex-1 px-3 space-y-1 overflow-y-auto">
        {/* Главная */}
        <SidebarMenuItem 
          {...mainMenuItems[0]}
          isActive={currentPath === mainMenuItems[0].path}
          collapsed={collapsed}
        />
        
        {/* Аренда с подменю */}
        <SidebarRentalSubmenu 
          collapsed={collapsed}
          currentPath={currentPath}
          isRentalActive={isRentalActive}
          rentalSubmenuOpen={rentalSubmenuOpen}
          onToggleSubmenu={collapsed ? () => {} : toggleRentalSubmenu}
        />
        
        {/* Остальные пункты меню */}
        {mainMenuItems.slice(1).map(item => {
          const isTasks = item.path === '/tasks';
          const extraProps = isTasks && displayCount > 0
            ? { badgeCount: displayCount, badgeVariant }
            : {};
          return (
            <SidebarMenuItem 
              key={item.path}
              {...item}
              {...extraProps}
              isActive={currentPath === item.path}
              collapsed={collapsed}
            />
          );
        })}
      </nav>
      
      <SidebarToggle collapsed={collapsed} onToggle={onToggle} />
    </div>
  );
};

export default Sidebar;
